import MuiCardContent, { CardContentProps as MuiCardContentProps } from '@mui/material/CardContent';
import * as React from 'react';

export interface CardContentProps extends MuiCardContentProps {}

export const CardContent = (props: CardContentProps) => {
  return <MuiCardContent {...props} />;
};
